export interface ISpreadSheetClick {
    sheetName: string;
    rowNo?: number;
    colNo?: number;
}
